/**
 * Guarda un área de comocimiento para formar el primer catálogo.
 */
export interface ICatalogoArea {
  id?: string;
  clave?: string;
  nombre?: string;
}

export class CatalogoArea implements ICatalogoArea {
  constructor(public id?: string, public clave?: string, public nombre?: string) {}
}

/**
 * Guarda el área del objeto Área de conocimiento
 */
export interface IArea {
  id?: string;
  nombre?: string;
  clave?: string;
  version?: string;
}

export class Area implements IArea {
  constructor(public id?: string, public nombre?: string, public clave?: string, public version?: string) {}
}

/**
 * Guardar el campo del objeto Área de conocimiento
 */
export interface ICampo {
  id?: string;
  nombre?: string;
  clave?: string;
  version?: string;
}

export class Campo implements ICampo {
  constructor(public id?: string, public nombre?: string, public clave?: string, public version?: string) {}
}

/**
 * Guarda la disciplina del objeto Área de conocimiento
 */
export interface IDisciplina {
  id?: string;
  nombre?: string;
  clave?: string;
  version?: string;
}

export class Disciplina implements IDisciplina {
  constructor(public id?: string, public nombre?: string, public clave?: string, public version?: string) {}
}

/**
 * Guarda la subdisciplina del objeto Área de conocimiento
 */
export interface ISubdisciplina {
  id?: string;
  nombre?: string;
  clave?: string;
  version?: string;
}

export class Subdisciplina implements ISubdisciplina {
  constructor(public id?: string, public nombre?: string, public clave?: string, public version?: string) {}
}

/**
 * Guarda el objeto Área de conocimiento
 */
export interface IAreaConocimiento {
  id?: string;
  area?: IArea;
  campo?: ICampo;
  disciplina?: IDisciplina;
  otraDisciplina?: string;
  subdisciplina?: ISubdisciplina;
  otraSubdisciplina?: string;
  esPrincipal?: boolean;
}

export class AreaConocimiento implements IAreaConocimiento {
  constructor(
    public id?: string,
    public area?: IArea,
    public campo?: ICampo,
    public disciplina?: IDisciplina,
    public otraDisciplina?: string,
    public subdisciplina?: ISubdisciplina,
    public otraSubdisciplina?: string,
    public esPrincipal?: boolean
  ) {}

  static fromObject(item: IAreaConocimiento): AreaConocimiento {
    const areaConocimiento = new AreaConocimiento();

    for (const [key, value] of Object.entries(item)) {
      areaConocimiento[key] = value;
    }

    return areaConocimiento;
  }
}

export interface IMenuCatalogoArea {
  text?: string;
  value?: ICatalogoArea;
}

export class MenuCatalogoArea implements IMenuCatalogoArea {
  constructor(public text?: string, public value?: ICatalogoArea) {}
}
